import { TextField, InputAdornment, IconButton, Box } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

const CorporateEntitiesSearchBar = ({ queryString, setQueryString }) => {
  return (
    <Box sx={{ width: 250 }}>
      <TextField
        fullWidth
        variant="outlined"
        size="small"
        placeholder="Search"
        value={queryString}
        onChange={(e) => setQueryString(e.target.value)}
        InputProps={{
          endAdornment: queryString && (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onClick={() => setQueryString('')}
                edge="end"
              >
                <CancelIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default CorporateEntitiesSearchBar;
